/* eslint-disable import/prefer-default-export */
import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { CircularProgress } from '@mui/material';
import { Center } from '../Containers';

interface Props {
  open: boolean;
  message?: string;
}

export const LoadingDialogue: React.FC<Props> = ({ open, message = 'Please wait, page is loading..' }) => {
  return (
    <Dialog open={open} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogContent>
        <Center my={2}>
          <CircularProgress thickness={8} />
        </Center>
        <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
      </DialogContent>
    </Dialog>
  );
};
